import { mode } from "@chakra-ui/theme-tools";
import { StyleFunctionProps } from "@chakra-ui/react";

interface TableStyleObject {
  [key: string]: any;
}

interface TableConfig {
  baseStyle: (props: StyleFunctionProps) => TableStyleObject;
}

export const tableStyles: TableConfig = {
  baseStyle: (props: StyleFunctionProps) => ({
    th: {
      borderColor: mode("gray.300", "gray.600")(props),
    },
    td: {
      borderColor: mode("gray.300", "gray.600")(props),
    },
    tbody: {
      tr: {
        borderBottomColor: mode("gray.300", "gray.600")(props),
      },
    },
  }),
};
